export const extensionUserKeyFields: string[] = ['userId', 'extensionId'];
